import React, { useState } from "react";
import styled from "styled-components";
import location_icon from "../../../assets/images/footer/location_icon.svg";
import mail_icon from "../../../assets/images/footer/mail_icon.svg";
import contact_icon from "../../../assets/images/footer/contact_icon.svg";
import twitter_icon from "../../../assets/images/Social_icon/twitter_icon.svg";
import facebook_icon from "../../../assets/images/Social_icon/facebook_icon.svg";
import linkedin_icon from "../../../assets/images/Social_icon/linkedin_icon.svg";
import insta_icon from "../../../assets/images/Social_icon/insta_icon.svg";

const FooterWrapper = styled.div`
  background: #2868c5 !important;
  a {
    text-decoration: none;
  }
  .logo {
    height: 130px;
    width: 230px;
  }
  .footer--main-container {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
  }
  .footer--container {
    padding: 51px 95px 32px 100px;
  }
  .sckilled--text {
    letter-spacing: 0.2em;
  }
  .skilled-description {
    max-width: 581px;
    width: 100%;
  }
  .footer-copyright-section {
    border-top: 1px solid #ffffff;
    padding-left: 135px;
    padding-right: 135px;
  }
  .email-submit-btn {
    width: max-content;
  }
  .footer-address,
  .about-us,
  .quick-link {
    width: 380px !important;
  }
  .social-icon {
    filter: grayscale(50);
  }
  .social-icon:hover {
    filter: brightness(100);
  }
  .about-us {
    width: auto;
    justify-self: center;
  }
  .quick-link {
    width: auto;
    justify-self: end;
  }
  .get-in-touch ul li {
    list-style-type: none;
  }
  .links-section {
    grid-gap: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .made-love-text {
    text-align: center;
  }
  .name-text:hover {
    color: #ffffff !important;
  }
  .footer--mobile-container {
    display: none;
  }
  @media only screen and (max-width: 870px) {
    .footer--container {
      padding: 50px 30px 32px 30px;
    }
    .footer-address {
      width: 280px !important;
    }
  }
  @media only screen and (max-width: 690px) {
    /* .footer--container {
      display: none;
    } */
    .get-in-touch {
      display: none;
    }
    .logo {
      height: 100px;
      width: 174px;
    }
    .top-containers {
      padding-bottom: 0;
    }
    .footer--container {
      padding: 0px 20px 0px;
    }
    .skilled-description {
      font-size: 12px !important;
    }
    .footer--mobile-container {
      display: flex;
      flex-direction: column;
      padding: 26px 15px 40px 17px;
    }
    .email--container-mobile input {
      border: 0.746154px solid #8991a4;
      border-radius: 5.96923px 0 0 5.96923px;
      color: #8991a4;
      width: calc(100% - 40px);
    }
    .email--container-mobile button {
      border-radius: 0px 5.96923px 5.96923px 0px;
    }
    .footer-copyright-section {
      flex-direction: column;
      text-align: center;
      font-size: 10px;
      padding: 9px 17px 16px 17px;
    }
    .social-icon-mobile {
      height: 16px;
    }
    .isContainerOpen {
      transform: rotate(180deg);
    }
  }
`;

const Footer = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isOpenCategory, setIsOpenCategory] = useState(false);
  return (
    <FooterWrapper>
      <div className="footer--main-container">
        <div className="footer--container white--text">
          <div>
            <div className="top-containers flex justify-between pb74 gap20">
              <div>
                <div className="flex gap22 pb22">
                  <img
                    src="https://techutsav-2023.web.app/img/Tech_Utsav_Logo-01-removebg-preview.png"
                    alt="logo"
                    className="logo"
                  />
                </div>
                <div className="font-16 skilled-description regular-text">
                  Apollo institute of Engineering & Technology is organizing a
                  Technical Event-" TECH उत्सव - 2023" during April 24th to
                  April 26th.Participate in the event to Network with the best
                  tech and non-tech head around the world who exchange ideas,
                  share knowledge and have fun together and win exciting prizes.
                </div>
              </div>

              <div className="get-in-touch">
                <div className="font-24 semi-bold-text pb27">Get in Touch</div>
                <ul className="pl0 mb0">
                  <li
                    className="font-16 regular-text flex pb8 cursor-pointer"
                    onClick={() =>
                      window.open(
                        "https://www.google.com/maps/place/Apollo+Institute+of+Engineering+and+Technology/@23.0989644,72.7075242,17z/data=!4m6!3m5!1s0x395e80a048ab6a0b:0x454d8f5d96b947eb!8m2!3d23.0989644!4d72.7075242!16s%2Fg%2F11b632lh6z"
                      )
                    }
                  >
                    <img src={location_icon} alt="location" className="pr20" />
                    <div className="footer-address">
                      <div className="full-width pb5">
                        Apollo Institute of Engineering and Technology
                      </div>
                      <div className="font-14">
                        SNME Campus, Near S.P. Ring Road Circle, Enasan, Gujarat
                        382330
                      </div>
                    </div>
                  </li>
                  <li className="font-16 regular-text flex py8">
                    <img src={contact_icon} alt="contact" className="pr20" />
                    <a href="tel:917600122122" className="white--text">
                      +91 76001 22122
                    </a>
                  </li>
                  <li className="font-16 regular-text flex pt8">
                    <img src={mail_icon} alt="mail" className="pr20" />
                    <a href="mailto: admin@aiet.edu.in" className="white--text">
                      admin@aiet.edu.in
                    </a>
                  </li>
                </ul>
                <div className="pt25">
                  <img
                    src={twitter_icon}
                    alt="twitter"
                    onClick={() =>
                      window.open("https://twitter.com/AIET_official?s=08")
                    }
                    className="social-icon pr15 cursor-pointer"
                  />
                  <img
                    src={facebook_icon}
                    alt="facebook"
                    onClick={() =>
                      window.open("https://www.facebook.com/apollocollege")
                    }
                    className="social-icon pr15 cursor-pointer"
                  />
                  <img
                    src={linkedin_icon}
                    alt="linkedin"
                    className="social-icon pr15 cursor-pointer"
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/school/official-aiet/?originalSubdomain=in"
                      )
                    }
                  />
                  <img
                    src={insta_icon}
                    alt="instagram"
                    onClick={() =>
                      window.open("https://www.instagram.com/aiet_official/")
                    }
                    className="social-icon cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer--mobile-container white--text">
          <div>
            <div
              className="flex justify-between pt20"
              onClick={() => {
                setSelectedCategory("get-in-touch");
                setIsOpenCategory(!isOpenCategory);
              }}
            >
              <div className="font-14 bold-text lh-28">Get In Touch</div>
              {/* <img src={down_arrow} alt="" className={`${selectedCategory === "get-in-touch" && isOpenCategory ? "isContainerOpen" : ""}`}/> */}
            </div>
            {/* {selectedCategory === "get-in-touch" && isOpenCategory && ( */}
            <ul className="pl15 mb0 pt10">
              <li className="font-12 regular-text flex pb8 items-center">
                <img
                  src={location_icon}
                  alt="location"
                  className="pr10"
                  style={{ height: "17px" }}
                />
                <div className="footer-address">
                  Apollo Institute of Engineering and Technology <br />
                  SNME Campus, Near S.P. Ring Road Circle, Enasan, Gujarat
                  382330
                </div>
              </li>
              <li className="font-12 regular-text flex py8">
                <img
                  src={contact_icon}
                  alt="contact"
                  className="pr10"
                  style={{ height: "17px" }}
                />
                <a href="tel:917600122122" className="white--text">
                  +91 76001 22122
                </a>
              </li>
              <li className="font-12 regular-text flex pt8">
                <img
                  src={mail_icon}
                  alt="mail"
                  className="pr10"
                  style={{ height: "17px" }}
                />
                <a href="mailto: admin@aiet.edu.in" className="white--text">
                  admin@aiet.edu.in
                </a>
              </li>
            </ul>
            {/* )}   */}
          </div>
          <div className="pt25">
            <img
              src={twitter_icon}
              alt="twitter"
              className="pr10 cursor-pointer social-icon-mobile"
            />
            <img
              src={facebook_icon}
              alt="facebook"
              className="pr10 cursor-pointer social-icon-mobile"
            />
            <img
              src={linkedin_icon}
              alt="linkedin"
              className="pr10 cursor-pointer social-icon-mobile"
            />
            <img
              src={insta_icon}
              alt="instagram"
              className="cursor-pointer social-icon-mobile"
            />
          </div>
        </div>
      </div>
      <div className="primary bordercolor--text flex justify-between pt30 pb32 footer-copyright-section items-center font-16">
        <div>
          Copyright ©{" "}
          <span
            className="white--text cursor-pointer"
            onClick={() => window.open("https://aiet.edu.in/")}
          >
            TechUtsav2023-AIET.
          </span>{" "}
          All Rights Reserved.
        </div>
        <div className="made-love-text">
          <div>Made with ❤ by</div>
          <div>
            <a
              href="https://sahilsutariya.vercel.app"
              target="_blank"
              className="name-text bordercolor--text"
            >
              Sahil Sutariya
            </a>
            , Darshan Vaghela & Param Patel
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
